import { z } from "zod";

export const achApprovalMethodSchema = z.enum([
  "MICRO_DEPOSIT",
  "PLAID",
  "PLAID_MICRO",
  "CORRESPONDENT",
  "PLAID_PARTNER",
]);

export const relationshipStatusSchema = z.enum([
  "QUEUED",
  "CANCEL_REQUESTED",
  "CANCEL_SENT",
  "CANCEL_FAILED",
  "PENDING",
  "SENT_TO_CLEARING",
  "APPROVED",
  "CANCELED",
  "REJECTED",
]);

export const plaidVerificationStatusSchema = z.union([
  z.enum([
    "automatically_verified",
    "pending_automatic_verification",
    "pending_manual_verification",
    "manually_verified",
    "verification_expired",
    "verification_failed",
  ]),
  z.string(),
]);

export const achRelationshipSchema = z.object({
  id: z.string(),
  clearing_id: z.string().nullish(),
  created_at: z.string(),
  updated_at: z.string().nullish(),
  deleted_at: z.string().nullish(),
  account_id: z.string(),
  status: relationshipStatusSchema,
  approval_method: achApprovalMethodSchema,
  plaid_institution: z.string().nullish(),
  plaid_verification_status: plaidVerificationStatusSchema
    .nullish()
    .catch(undefined),
  mask: z.string().nullish(),
  account_name: z.string().nullish(),
  expires_at: z.string().nullish(),
  failed_attempts: z.number().nullish(),
  reason: z.string().nullish(),
  micro_deposit_id: z.string().nullish(),
  micro_deposit_status: z.string().nullish(),
  processor_token: z.string().nullish(),
  correspondent_code: z.string().nullish(),
});

export const bankRelationshipSchema = z.object({
  id: z.string(),
  account_id: z.string(),
  status: relationshipStatusSchema,
  approval_method: achApprovalMethodSchema,
  account_name: z.string().nullish(),
  account_mask: z.string().nullish(),
  plaid_institution: z.string().nullish(),
  plaid_verification_status: plaidVerificationStatusSchema.nullish(),
  created_at: z.string(),
  expires_at: z.string().nullish(),
});
